export const contactsData = {
  email: "shresthabikash2073@gmail.com",
  phone: "+977 9865183709",
  address: "Kathmandu, Nepal",

  sheetAPI: "",
};
